// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml = require("rescript/lib/js/caml.js");
var Utils = require("../../utils/Utils.bs.js");
var React = require("react");
var IconV5 = require("../../uikit/atoms/Icon/IconV5.bs.js");
var MenuV5 = require("../common/Components/menu/MenuV5.bs.js");
var Numeral = require("../../utils/Numeral.bs.js");
var ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var IconButton = require("../../reason/common/IconButton.bs.js");
var Text__Jsx3 = require("../../uikit/reason/helpers/Text__Jsx3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var Types__Common = require("../../reason/common/types/Types__Common.bs.js");
var Belt_SortArray = require("rescript/lib/js/belt_SortArray.js");
var TailwindMerge = require("tailwind-merge");
var TMPUIKIT____Page = require("../../temporaryUIKit/TMPUIKIT____Page/TMPUIKIT____Page.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var NotificationSettingsUtils = require("./NotificationSettingsUtils.bs.js");
var UnselectedUnionMemberError = require("../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
var NotificationSettingsComponents_group_graphql = require("../../__generated__/NotificationSettingsComponents_group_graphql.bs.js");
var NotificationSettingsComponents_byType_graphql = require("../../__generated__/NotificationSettingsComponents_byType_graphql.bs.js");
var NotificationSettingsEntitySettingConfirmationModal = require("./NotificationSettingsEntitySettingConfirmationModal.bs.js");
var NotificationSettingsComponentsAreaGroupItem_chapter_graphql = require("../../__generated__/NotificationSettingsComponentsAreaGroupItem_chapter_graphql.bs.js");
var NotificationSettingsComponentsPreferenceSummary_chapter_graphql = require("../../__generated__/NotificationSettingsComponentsPreferenceSummary_chapter_graphql.bs.js");

function settingToString(p) {
  switch (p) {
    case "CHAPTER_DEFAULT" :
        return "All broadcasts in my chapter";
    case "CUSTOM" :
        return "Those that match custom filters";
    case "MATCH_ONLY" :
        return "Matches only";
    
  }
}

function NotificationSettingsComponents$SettingsSelector(props) {
  var onChange = props.onChange;
  var value = props.value;
  var disabled = props.disabled;
  var settings = [
    "CHAPTER_DEFAULT",
    "CUSTOM",
    "MATCH_ONLY"
  ];
  return JsxRuntime.jsx(MenuV5.Menu.make, {
              button: JsxRuntime.jsx(ButtonsV5.Button.make, {
                    className: "!font-normal !normal-case !py-2",
                    children: Caml_option.some(JsxRuntime.jsxs("div", {
                              children: [
                                settingToString(value),
                                JsxRuntime.jsx(IconV5.make, {
                                      icon: "arrow-down",
                                      size: 14,
                                      className: "text-gray-500"
                                    })
                              ],
                              className: "flex items-center justify-between gap-4 "
                            }))
                  }),
              children: settings.map(function (setting) {
                    return JsxRuntime.jsx(MenuV5.MenuItem.make, {
                                onAction: (function () {
                                    onChange(setting);
                                  }),
                                isDisabled: disabled || setting === value,
                                children: settingToString(setting)
                              }, setting);
                  })
            });
}

var SettingsSelector = {
  settingToString: settingToString,
  make: NotificationSettingsComponents$SettingsSelector
};

function NotificationSettingsComponents$PreferenceSelectorForm(props) {
  var onPressEdit = props.onPressEdit;
  var __renderSummary = props.renderSummary;
  var onChange = props.onChange;
  var value = props.value;
  var disabled = props.disabled;
  var renderSummary = __renderSummary !== undefined ? Caml_option.valFromOption(__renderSummary) : null;
  var match = React.useState(function () {
        return false;
      });
  var setConfirmMatchOnly = match[1];
  var tmp;
  switch (value) {
    case "CUSTOM" :
        tmp = JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
              onClick: (function (param) {
                  onPressEdit();
                }),
              disabled: disabled,
              children: Caml_option.some(JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx(IconV5.make, {
                                icon: "pencil"
                              }),
                          JsxRuntime.jsx(Text__Jsx3.make, {
                                fontSize: {
                                  NAME: "px",
                                  VAL: 14
                                },
                                textTransform: "capitalize",
                                fontWeight: {
                                  NAME: "num",
                                  VAL: 400
                                },
                                children: "Edit filters"
                              })
                        ],
                        className: "flex flex-row space-x-2 py-0.5"
                      }))
            });
        break;
    case "CHAPTER_DEFAULT" :
    case "MATCH_ONLY" :
        tmp = null;
        break;
    
  }
  var tmp$1;
  switch (props.entityType) {
    case "BUYER_NEED" :
        tmp$1 = "BuyerNeedOnlyMatches";
        break;
    case "FOR_SALE_PROPERTY" :
        tmp$1 = "PropertyOnlyMatches";
        break;
    case "RENTAL_NEED" :
        tmp$1 = "RentalNeedOnlyMatches";
        break;
    case "RENTAL_PROPERTY" :
        tmp$1 = "RentalPropertyOnlyMatches";
        break;
    
  }
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(TMPUIKIT____Page.Subtitle.make, {
                      children: props.title
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("div", {
                            children: props.text,
                            className: "leading-relaxed"
                          })
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx(NotificationSettingsComponents$SettingsSelector, {
                              disabled: disabled,
                              value: value,
                              onChange: (function (v) {
                                  switch (v) {
                                    case "CHAPTER_DEFAULT" :
                                    case "CUSTOM" :
                                        break;
                                    case "MATCH_ONLY" :
                                        return setConfirmMatchOnly(function (param) {
                                                    return true;
                                                  });
                                    
                                  }
                                  setConfirmMatchOnly(function (param) {
                                        return false;
                                      });
                                  onChange(v);
                                })
                            }),
                        tmp
                      ],
                      className: "flex flex-row items-center gap-4 mt-4 flex-wrap"
                    }),
                renderSummary,
                JsxRuntime.jsx(NotificationSettingsEntitySettingConfirmationModal.make, {
                      isOpen: match[0],
                      onConfirm: (function () {
                          onChange("MATCH_ONLY");
                          setConfirmMatchOnly(function (param) {
                                return false;
                              });
                        }),
                      onCancel: (function () {
                          setConfirmMatchOnly(function (param) {
                                return false;
                              });
                        }),
                      confirmationType: tmp$1
                    })
              ],
              className: "mt-7"
            });
}

var PreferenceSelectorForm = {
  make: NotificationSettingsComponents$PreferenceSelectorForm
};

var matchableEntityType_decode = NotificationSettingsComponents_group_graphql.Utils.matchableEntityType_decode;

var convertFragment = NotificationSettingsComponents_group_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationSettingsComponents_group_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationSettingsComponents_group_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, NotificationSettingsComponents_group_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(NotificationSettingsComponents_group_graphql.node, convertFragment, fRef);
}

var GroupFragment_matchableEntityType_fromString = NotificationSettingsComponents_group_graphql.Utils.matchableEntityType_fromString;

var GroupFragment = {
  matchableEntityType_decode: matchableEntityType_decode,
  matchableEntityType_fromString: GroupFragment_matchableEntityType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

var convertFragment$1 = NotificationSettingsComponents_byType_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationSettingsComponents_byType_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationSettingsComponents_byType_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, NotificationSettingsComponents_byType_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(NotificationSettingsComponents_byType_graphql.node, convertFragment$1, fRef);
}

var ByTypeFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

var convertFragment$2 = NotificationSettingsComponentsAreaGroupItem_chapter_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationSettingsComponentsAreaGroupItem_chapter_graphql.node, convertFragment$2, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationSettingsComponentsAreaGroupItem_chapter_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, NotificationSettingsComponentsAreaGroupItem_chapter_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(NotificationSettingsComponentsAreaGroupItem_chapter_graphql.node, convertFragment$2, fRef);
}

var ChapterFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$2,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

var bullet = '\u2022';

function NotificationSettingsComponents$AreaGroupItem$AreaItem(props) {
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: bullet
                    }),
                JsxRuntime.jsx("div", {
                      children: props.children
                    })
              ],
              className: "flex flex-row items-center space-x-2 pl-0.5 mt-2"
            });
}

var AreaItem = {
  bullet: bullet,
  make: NotificationSettingsComponents$AreaGroupItem$AreaItem
};

function NotificationSettingsComponents$AreaGroupItem(props) {
  var chapter = use$2(props.chapter);
  var areaGroup = use(props.areaGroup);
  var byType = use$1(areaGroup.fragmentRefs);
  var match = React.useState(function () {
        return false;
      });
  var setIsOpen = match[1];
  var isOpen = match[0];
  var chapterName = chapter.displayName;
  var nTypes = NotificationSettingsUtils.notificationTypesString(Core__Array.filterMap(Core__Option.getOr(areaGroup.usedFor, []), (function (t) {
              return matchableEntityType_decode(t);
            })));
  var tmp;
  switch (byType.__typename) {
    case "ChapterAreaGroup" :
        tmp = chapterName + " chapter areas";
        break;
    case "UserAreaGroup" :
        tmp = "Custom area group for " + nTypes;
        break;
    case "__unselected" :
        tmp = UnselectedUnionMemberError.raise("Unselected area group type: " + byType._0);
        break;
    
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx(IconV5.make, {
                                    icon: isOpen ? "arrow-down" : "arrow-right",
                                    size: 12
                                  }),
                              JsxRuntime.jsx("div", {
                                    children: tmp
                                  })
                            ],
                            className: "flex flex-row items-center space-x-2"
                          }),
                      className: "hover:cursor-pointer mt-2",
                      onClick: (function (param) {
                          setIsOpen(function (v) {
                                return !v;
                              });
                        })
                    }),
                isOpen ? JsxRuntime.jsx("div", {
                        children: Belt_SortArray.stableSortBy(Core__Array.keepSome(Core__Option.getOr(areaGroup.areas, [])), (function (a1, a2) {
                                  return Caml.string_compare(a1.label, a2.label) | 0;
                                })).map(function (param) {
                              return JsxRuntime.jsx(NotificationSettingsComponents$AreaGroupItem$AreaItem, {
                                          children: param.label
                                        }, param.id);
                            }),
                        className: "ml-4"
                      }) : null
              ]
            });
}

var AreaGroupItem = {
  GroupFragment: GroupFragment,
  ByTypeFragment: ByTypeFragment,
  ChapterFragment: ChapterFragment,
  AreaItem: AreaItem,
  make: NotificationSettingsComponents$AreaGroupItem
};

var convertFragment$3 = NotificationSettingsComponentsPreferenceSummary_chapter_graphql.Internal.convertFragment;

function waitForFragmentData$3(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationSettingsComponentsPreferenceSummary_chapter_graphql.node, convertFragment$3, fRef);
}

function use$3(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationSettingsComponentsPreferenceSummary_chapter_graphql.node, convertFragment$3, fRef);
}

function useOpt$3(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, NotificationSettingsComponentsPreferenceSummary_chapter_graphql.node, convertFragment$3);
}

function readResolverFragment$3(fRef) {
  return RescriptRelay_Fragment.read(NotificationSettingsComponentsPreferenceSummary_chapter_graphql.node, convertFragment$3, fRef);
}

var ChapterFragment$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$3,
  waitForFragmentData: waitForFragmentData$3,
  use: use$3,
  useOpt: useOpt$3,
  readResolverFragment: readResolverFragment$3
};

var ndash = '\u2013';

function NotificationSettingsComponents$PreferenceSummary$Item(props) {
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: ndash
                    }),
                JsxRuntime.jsx("div", {
                      children: props.children
                    })
              ],
              className: "flex flex-row space-x-2 items-center pl-0.5 mt-2"
            });
}

var Item = {
  ndash: ndash,
  make: NotificationSettingsComponents$PreferenceSummary$Item
};

function NotificationSettingsComponents$PreferenceSummary(props) {
  var mlsStatus = props.mlsStatus;
  var propertyTypes = props.propertyTypes;
  var maxPrice = props.maxPrice;
  var minPrice = props.minPrice;
  var chapter = use$3(props.chapter);
  var propertyTypes$1 = props.tanType === "Rental" ? propertyTypes.filter(function (x) {
          switch (x) {
            case "LOT" :
            case "MULTI_UNIT" :
                return false;
            case "CONDO" :
            case "SINGLE_FAMILY" :
                return true;
            
          }
        }) : propertyTypes;
  var priceText = minPrice !== undefined ? (
      maxPrice !== undefined ? "From " + (Numeral.formatPrice(minPrice) + (" to " + Numeral.formatPrice(maxPrice))) : "From " + Numeral.formatPrice(minPrice)
    ) : (
      maxPrice !== undefined ? "Up to " + Numeral.formatPrice(maxPrice) : undefined
    );
  var mlsStatusText = mlsStatus !== undefined && mlsStatus !== "ANY" ? "Not active on the MLS" : undefined;
  var tmp;
  if (propertyTypes$1.length !== 0) {
    var propertyTypesText = Utils.$$Array.join(", ", " and ", propertyTypes$1.map(function (v) {
              return Types__Common.PropertyType.toDisplayString(v);
            })) + " properties";
    tmp = JsxRuntime.jsx(NotificationSettingsComponents$PreferenceSummary$Item, {
          children: propertyTypesText
        });
  } else {
    tmp = null;
  }
  return JsxRuntime.jsxs("div", {
              children: [
                tmp,
                Core__Option.getOr(Core__Option.map(priceText, (function (t) {
                            return JsxRuntime.jsx(NotificationSettingsComponents$PreferenceSummary$Item, {
                                        children: t
                                      });
                          })), null),
                Core__Option.getOr(Core__Option.map(mlsStatusText, (function (t) {
                            return JsxRuntime.jsx(NotificationSettingsComponents$PreferenceSummary$Item, {
                                        children: t
                                      });
                          })), null),
                JsxRuntime.jsx(NotificationSettingsComponents$AreaGroupItem, {
                      areaGroup: props.areaGroup,
                      chapter: chapter.fragmentRefs
                    })
              ],
              className: "p-2"
            });
}

var PreferenceSummary = {
  ChapterFragment: ChapterFragment$1,
  Item: Item,
  make: NotificationSettingsComponents$PreferenceSummary
};

function areaTypeLabel(x) {
  switch (x) {
    case "BLOCK_GROUP" :
        return "Block Groups";
    case "CENSUS_PLACE" :
    case "CITY" :
        return "Cities";
    case "COUNTY" :
        return "Counties";
    case "NEIGHBORHOOD" :
        return "Neighborhoods";
    case "SCHOOL" :
        return "Schools";
    case "SCHOOL_DISTRICT" :
        return "School Districts";
    case "STATE" :
        return "States";
    case "TOWNSHIP" :
        return "Townships";
    case "ZIP_CODE" :
        return "Zip Codes";
    
  }
}

function NotificationSettingsComponents$AreaTypesList(props) {
  var __style = props.style;
  var __showCount = props.showCount;
  var onRemoveArea = props.onRemoveArea;
  var areaType = props.areaType;
  var areas = props.areas;
  var showCount = __showCount !== undefined ? __showCount : true;
  var style = __style !== undefined ? __style : "Striped";
  var tmp;
  tmp = style === "Striped" ? "border-b" : "";
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("span", {
                      children: areaTypeLabel(areaType),
                      className: "text-gray-800 font-semibold"
                    }),
                showCount ? " (" + areas.length.toString() + ")" : null,
                JsxRuntime.jsx("ul", {
                      children: areas.map(function (area) {
                            var tmp;
                            tmp = style === "Striped" ? "border-t py-2 even:bg-gray-50 odd:bg-white" : "";
                            return JsxRuntime.jsxs("li", {
                                        children: [
                                          JsxRuntime.jsx("div", {
                                                children: area.label
                                              }),
                                          onRemoveArea !== undefined ? JsxRuntime.jsx(IconButton.make, {
                                                  icon: "cancel",
                                                  onPress: (function () {
                                                      onRemoveArea(area.id);
                                                    }),
                                                  title: area.label
                                                }) : null
                                        ],
                                        className: TailwindMerge.twMerge([
                                              "text-base font-normal pl-3 flex items-center justify-between",
                                              tmp
                                            ])
                                      }, area.id);
                          }),
                      className: TailwindMerge.twMerge([
                            "pt-1 list-none",
                            tmp
                          ])
                    })
              ]
            }, areaType);
}

var AreaTypesList = {
  areaTypeLabel: areaTypeLabel,
  make: NotificationSettingsComponents$AreaTypesList
};

exports.SettingsSelector = SettingsSelector;
exports.PreferenceSelectorForm = PreferenceSelectorForm;
exports.AreaGroupItem = AreaGroupItem;
exports.PreferenceSummary = PreferenceSummary;
exports.AreaTypesList = AreaTypesList;
/* Utils Not a pure module */
